import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { LOGO_NAV_URL } from '../../brand/logo';
import { QNAREAD } from '../../config/appLabels';
import MarketingLoginLink from './MarketingLoginLink';
import './marketing.css';

export default function MarketingShell({ title, children, variant = 'brand', layout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const pageClass = [
    variant === 'product' ? 'marketing-page marketing-page--product' : 'marketing-page marketing-page--brand',
    layout === 'hub' ? 'marketing-page--hub' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const navClass = ({ isActive }) => (isActive ? 'marketing-nav-active' : undefined);

  return (
    <div className={pageClass}>
      {layout === 'hub' && <div className="marketing-hub-bg" aria-hidden="true" />}
      <header className="marketing-header">
        <Link to="/product" className="marketing-brand">
          <img src={LOGO_NAV_URL} alt="QnaRead logo" width={36} height={36} />
          <span className="marketing-brand-copy">
            <span className="marketing-brand-name">QnaRead.com</span>
            <span className="marketing-brand-tagline">{QNAREAD.taglineShort}</span>
          </span>
        </Link>
        <button
          type="button"
          className="marketing-menu-btn"
          aria-expanded={menuOpen}
          aria-label="Open menu"
          onClick={() => setMenuOpen(true)}
        >
          Menu
        </button>
        <nav className="marketing-nav" aria-label="Marketing">
          <NavLink to="/product" className={navClass} end>
            Product
          </NavLink>
          <NavLink to="/features" className={navClass}>
            Tour
          </NavLink>
          <NavLink to="/pricing" className={navClass}>
            Pricing
          </NavLink>
          <NavLink to="/security" className={navClass}>
            Security
          </NavLink>
          <NavLink to="/contact" className={navClass}>
            Contact
          </NavLink>
          <MarketingLoginLink className="marketing-cta marketing-cta-outline">
            Sign in
          </MarketingLoginLink>
          <MarketingLoginLink className="marketing-btn marketing-btn-primary marketing-nav-signup">
            Get started
          </MarketingLoginLink>
        </nav>
      </header>

      {menuOpen && (
        <>
          <button type="button" className="marketing-drawer-backdrop" aria-label="Close" onClick={() => setMenuOpen(false)} />
          <div className="marketing-drawer" role="dialog" aria-label="Site menu">
            <button type="button" className="marketing-drawer-close" onClick={() => setMenuOpen(false)}>×</button>
            <Link to="/product" onClick={() => setMenuOpen(false)}>Product</Link>
            <Link to="/features" onClick={() => setMenuOpen(false)}>Tour</Link>
            <Link to="/pricing" onClick={() => setMenuOpen(false)}>Pricing</Link>
            <Link to="/security" onClick={() => setMenuOpen(false)}>Security</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
            <MarketingLoginLink
              className="marketing-btn marketing-btn-primary"
              redirect={location.pathname}
              onNavigate={() => setMenuOpen(false)}
            >
              Sign in / Get started
            </MarketingLoginLink>
          </div>
        </>
      )}

      <main className={`marketing-main ${variant === 'product' ? 'marketing-main--product' : ''}`}>
        {title ? <h1 className="marketing-page-title">{title}</h1> : null}
        {children}
      </main>
      <footer className="marketing-footer">
        <Link to="/about">About</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/cookies">Cookies</Link>
        <Link to="/contact">Contact</Link>
        <span>© {new Date().getFullYear()} QnaRead</span>
      </footer>
    </div>
  );
}
